// Utility function to convert a string to slug format
export const convertToSlug = (tag: string) => {
    return tag
      .toLowerCase()
      .replace(/\s+/g, '-')    // Replace spaces with hyphens
      .replace(/[^\w\-]+/g, ''); // Remove non-word characters
  };
  
  // Utility function to convert a string to title format (capitalize each word)
  export const convertToTitle = (tag: string) => {
    return tag
      .split('-')               // Split by hyphen (from slug format)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
      .join(' ');               // Join the words back with spaces
  };
  